/**
 * Formats a v3 resource `version` as the strong ETag that conditional v3 writes
 * require in `If-Match` — a double-quoted positive integer, e.g. `"3"`.
 *
 * The wildcard `*` is **not** accepted on these routes: the gateway validates
 * `If-Match` against `/^"[1-9]\d*"$/` and otherwise answers
 * `422 ValidationError — "If-Match must be the strong <Resource> ETag."`. So a
 * caller must carry the version from the latest read or write of that exact
 * resource; every v3 resource body that supports conditional writes exposes it
 * as `version`.
 */
export const strongETag = (version: number): string => `"${version}"`;
